<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          @click="handleEdit(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >修改</el-button>

        <el-button
          class="button"
          type="text"
          size="small"
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleView(scope.data, scope.$index)"
        >详情</el-button>

        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
        :type="type"
        @on-upload="handleFile"
      ></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button :disabled="loading || fileUploading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button
          :disabled="fileUploading"
          :loading="loading"
          class="line-button"
          @click="submitFrom"
        >确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { getDropPlantationList, getCropTestReportList, delCropTestReport } from '@/api/system/manage'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/detail/detection/components/form'
import Detail from '@/views/detail/detection/components/detail'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    Detail,
  },
  data() {
    return {
      type: '',
      queryParams: {},
      loading: false,
      fileUploading: false,
      authIdentity: 'detail:detection',
      dialogVisible: false,
      title: '',
      currentView: '',
      colLists: [
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'locName',
          label: '果园区域',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'pesticideTestPassedText',
          label: '农残',
          isTrue: true,
        },
        {
          prop: 'heavyMetalTestPassedText',
          label: '重金属',
          isTrue: true,
        },
        {
          prop: 'createBy',
          label: '登记员',
          isTrue: true,
        },
        {
          prop: 'testDate',
          label: '农残检测日期',
          isTrue: true,
          width: 120,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'codeBizNo',
          list: [],
          type: 'select',
        },
        {
          model: 'testDateTime',
          placeholder: '农残检测年份',
          class: 'home',
          type: 'year',
        },
        {
          model: 'isPesticideTestPassed',
          placeholder: '请选择农残结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.pesticideTestPassedStatus2,
          type: 'select',
        },
        {
          model: 'isHeavyMetalTestPassed',
          placeholder: '请选择重金属结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.heavyMetalTestPassedStatus2,
          type: 'select',
        },
      ],
    }
  },
  created() {
    this.getDropPlantations()
    this.getList()
  },
  methods: {
    getDropPlantations() {
      getDropPlantationList().then((res) => {
        if (res.flag) {
          res.data.forEach((item) => {
            item.codeBizNo = item.bizNo + '-' + item.name
          })
          this.selectOrInputList[0].list = res.data
        }
      })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getCropTestReportList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.locName = this.formatLocal(item.locDetails, 3)
              item.testDate = this.parseTime(item.testDateTime, '{y}-{m}-{d}')
              item.pesticideTestPassedText = CONSTANTS.getStatusConversionForYear(
                item.isPesticideTestPassed,
                'pesticideTestPassedStatus2',
                item.testDateTime
              )
              item.heavyMetalTestPassedText = CONSTANTS.getStatusConversionForYear(
                item.isHeavyMetalTestPassed,
                'heavyMetalTestPassedStatus2',
                item.testDateTime
              )
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleFile(file) {
      this.fileUploading = file.fileUploading
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.fileUploading = false
          this.cancel()
          this.getList()
        })
        .catch(() => {
          this.loading = false
          this.fileUploading = false
        })
    },
    cancel() {
      if (this.loading || this.fileUploading) {
        return
      }
      // this.$refs[this.currentView].reset()
      this.dialogVisible = false
    },
    handleAdd() {
      this.type = 'add'
      this.title = '新增农残检测'
      this.dialogVisible = true
      this.currentView = 'myform'
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看农残检测'
      this.dialogVisible = true
      this.currentView = 'Detail'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleEdit(row) {
      this.type = 'edit'
      this.title = '修改农残检测'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delCropTestReport(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
/deep/ .delbutton.el-button--text {
  color: red;
}
/deep/ .el-button--text {
  font-size: 14px;
}
</style>